import React from 'react';
import { Link } from 'react-router-dom';

function Orthopedics() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .ortho-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Orthopedics & Robotic Joint Replacement in Delhi NCR: Premium Private Care Medical Tourism Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Living with chronic joint degradation, advanced osteoarthritis, or complex spine conditions can completely restrict your physical freedom. When faced with exorbitant out-of-pocket costs or long waiting lists back home, traveling overseas presents a highly viable solution. 
          By researching options through independent informational platforms like <strong>Medical Trip World</strong>, international patients can analyze elite private orthopedic facilities across the Delhi National Capital Region (NCR)—including New Delhi, Gurgaon, and Noida—to save up to <strong>70%</strong> on advanced reconstructive procedures while maintaining access to world-class clinical expertise.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#005ba1', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,5ba,161,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Consult Joint Specialist Now →
        </Link>
      </div>

      {/* SECTION 1: SYSTEM OVERVIEW & FEATURED PACKAGES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Regain Mobility with Advanced Reconstructive Care
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Private multi-specialty centers across Delhi NCR deploy cutting-edge computer-navigated systems to execute precise structural joint re-alignments. International travelers can seamlessly access minimally invasive, high-flex knee replacement and total hip surgeries performed by world-renowned orthopedic consultants using top-tier, FDA-approved implants.
        </p>
        
        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '20px 0', borderRadius: '6px', borderLeft: '4px solid #ff9f1c', border: '1px solid #e2e8f0', borderLeftColor: '#ff9f1c', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#0b3c5d', fontSize: '1.15rem', marginBottom: '12px' }}> Legged Orthopedic Packages 2026:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'circle', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '6px' }}><strong>Unilateral Knee Replacement:</strong> Involves a 4 to 5-day inpatient hospital stay accompanied by early mobilization protocols.</li>
            <li style={{ marginBottom: '6px' }}><strong>Bilateral Total Joint Reconstruction:</strong> Uses advanced computer-assisted navigation and 3D optical sensors to balance ligaments precisely during multi-joint surgeries.</li>
            <li style={{ marginBottom: '0' }}><strong>Comprehensive Physiotherapy & Stay Logistics Facilitation:</strong> Integrated rehabilitation maps paired with professional ground support coordinates to optimize long-term implant longevity.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 2: SEO COST MAGNET MATRIX - SAFELY WRAPPED */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Estimated Global Costs: Private Orthopedic Surgery Comparison
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Evaluating global out-of-pocket expenses is an essential pre-planning metric for medical tourists. The benchmarks below reflect estimated cost ranges derived from open private sector pricing registries and historical medical travel statistics:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Estimated Private Joint Replacement Benchmarks (USD):</h3>
          
          {/* Scroll Protective Wrapper Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Procedure Category</th>
                  <th style={{ padding: '10px 8px' }}>United States (Private)</th>
                  <th style={{ padding: '10px 8px' }}>United Kingdom (Private)</th>
                  <th style={{ padding: '10px 8px', color: '#28a745' }}>Global Range (Delhi NCR Private)</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Total Knee Replacement (Single)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$35,000 - $50,000</td>
                  <td style={{ padding: '10px 8px' }}>$16,000 - $22,000</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$4,500 - $6,000</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Total Hip Replacement (Single)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$40,000 - $55,000</td>
                  <td style={{ padding: '10px 8px' }}>$18,000 - $24,000</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$5,000 - $7,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Data Notice: The financial figures listed above serve purely as broad informational benchmarks. Definitive pricing estimates depend directly on specific private facility selection, hardware model specifications (e.g., cobalt-chrome vs. ceramic configurations), and custom bone density scans.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: REHABILITATION & STERILITY METRICS - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Quality Metrics for Private Joint Replacement Hubs
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates exclusively as an open informational directory and research index, we advise international families to directly verify chosen institutions based on strict clinical baselines:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Laminar Airflow Operating Theaters</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm that the private facility utilizes advanced laminar flow air-circulation arrays inside orthopedic operating rooms to eliminate airborne particles and maximize infection control.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>In-House Physiotherapy Frameworks</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Successful arthroplasty results require immediate rehabilitation. Verify that your target private institution houses a dedicated physical therapy wing to start mobilization cycles within 24 hours post-op.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Private Orthopedic Tourism
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>How long must an international patient stay in Delhi NCR after total joint replacement surgery?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Typically, patients spend 4 to 5 days as an inpatient inside the private facility. Following discharge, orthopedic surgeons strongly advise remaining locally for an extra 10 to 14 days to undergo intensive outpatient physical therapy and ensure the structural stability of the joint before clearing flight boarding.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are global orthopedic implant brands used in Indian private medical centers?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Premium corporate healthcare institutions across New Delhi and Gurgaon utilize the exact same FDA-approved, internationally traceable implant brands (such as Stryker, Zimmer Biomet, and Smith & Nephew) standard in major Western medical systems.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World maintain official partnerships with specific orthopedic networks?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational reference manual and open directory. We do not provide medical services, contract nursing teams, or maintain active Memorandums of Understanding (MOUs) or partnerships with any private healthcare group. All definitive evaluations, treatment packages, and financial clearances are negotiated directly and solely between the patient and their self-selected healthcare professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="ortho-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="ortho-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Orthopedics;